"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SVGLoaders = __importStar(require("svg-loaders-react"));
var preloader_type_enum_1 = __importDefault(require("../../shared/enums/preloader-type.enum"));
var priority_enum_1 = __importDefault(require("../../shared/enums/priority.enum"));
var size_enum_1 = __importDefault(require("../../shared/enums/size.enum"));
var classMap_1 = __importDefault(require("../../shared/utilities/classMap"));
function Preloader(props) {
    var _a, _b;
    var type = (_a = props.type) !== null && _a !== void 0 ? _a : preloader_type_enum_1.default.GRID;
    var Loader = SVGLoaders[type];
    return (react_1.default.createElement("div", { className: (0, classMap_1.default)("mpng-ux-preloader", type.toLowerCase(), "size", props.size || size_enum_1.default.SMALL, props.className) },
        react_1.default.createElement(Loader, { className: (0, classMap_1.default)("w-100 h-100", "fill fill-".concat((_b = props.fill) !== null && _b !== void 0 ? _b : priority_enum_1.default.PRIMARY), props.stroke ? "stroke stroke-".concat(props.stroke) : ""), strokeOpacity: props.strokeOpacity || 1 })));
}
exports.default = Preloader;
